import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    submitUrl: String,
    pointsRemaining: Number,
    maxPoints: Number
  }
  static targets = ["input"]

  connect() {
    this.autoSaveTimers = new Map()
    this.inputTargets.forEach(input => {
      input.dataset.currentPoints = input.value || "0"
    })
  }

  disconnect() {
    this.autoSaveTimers.forEach(timer => clearTimeout(timer))
  }

  calculate(event) {
    const input = event.currentTarget
    const value = parseInt(input.value) || 0
    const currentPoints = parseInt(input.dataset.currentPoints) || 0

    const maxAllowed = this.pointsRemainingValue + currentPoints
    const clamped = Math.max(0, Math.min(value, maxAllowed))

    if (clamped < value) input.value = clamped

    this.pointsRemainingValue -= (clamped - currentPoints)
    input.dataset.currentPoints = clamped
    this.updatePointsDisplay()

    this.scheduleAutoSave(input, clamped)
  }

  scheduleAutoSave(input, points) {
    const assetId = input.dataset.assetId
    if (this.autoSaveTimers.has(assetId)) clearTimeout(this.autoSaveTimers.get(assetId))
    this.autoSaveTimers.set(assetId, setTimeout(() => this.saveBid(input, assetId, points), 500))
  }

  async saveBid(input, assetId, points) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(this.submitUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ bids: [{ asset_id: parseInt(assetId), points }] })
      })

      if (response.ok) {
        const data = await response.json()
        if (data.points_remaining !== undefined) {
          this.pointsRemainingValue = data.points_remaining
          this.updatePointsDisplay()
        }
      }
    } catch (error) {
      console.error("Auto-save failed:", error)
    }
  }

  updatePointsDisplay() {
    const listDisplay = document.getElementById("list-points-remaining")
    if (listDisplay) listDisplay.textContent = this.pointsRemainingValue

    const globalBadge = document.getElementById("points-remaining-value")
    if (globalBadge) globalBadge.textContent = this.pointsRemainingValue
  }
}
